// (B) 플레인 Switch — antd Switch 대체(순수 시각). antd DOM 미러링:
// button[role=switch].om-switch(+.om-switch-checked/-small/-disabled) > .om-switch-handle.
// 소비처 SCSS(setting-om-switch 믹스인 등)가 트랙/핸들 색을 .om-switch::before/.om-switch-handle::before 로
// 정의하고, 핸들 슬라이드 위치는 base(styles/omSwitch.css)에 의존 → 여기서 antd base 재현 필수.
import type { OmwSwitchProps } from '../api/OmwSwitch'
import { cx } from './cx'
import '../styles/omwSwitch.css'

export function PlainSwitch({
  checked,
  onChange,
  disabled,
  size = 'md',
  className,
  style,
  'data-testid': dataTestid,
}: OmwSwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked ?? false}
      disabled={disabled}
      className={cx(
        'om-switch',
        checked && 'om-switch-checked',
        size === 'sm' && 'om-switch-small',
        disabled && 'om-switch-disabled',
        className,
      )}
      style={style}
      data-testid={dataTestid}
      onClick={() => {
        if (!disabled) onChange?.(!checked)
      }}
    >
      <div className="om-switch-handle" />
    </button>
  )
}
